import type { AdminEventRegistration } from "../services/eventRegistrationAdminTypes";

function csvEscape(value: unknown) {
  const text = String(value ?? "");
  if (!/[;"\n\r]/.test(text)) return text;
  return `"${text.replace(/"/g, '""')}"`;
}

function buildFileSlug(value: string) {
  return (
    value
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 60) || "evento"
  );
}

export function downloadShirtSizesCsv({
  challengeName,
  registrations,
}: {
  challengeName: string;
  registrations: AdminEventRegistration[];
}) {
  const rows = registrations
    .filter((registration) => registration.status !== "canceled")
    .flatMap((registration) => {
      const common = {
        event: challengeName,
        category: String(registration.registrationCategoryName || "").trim(),
        registrationType:
          registration.registrationType === "fixed_pair"
            ? "Dupla fixa"
            : "Individual",
      };
      const player = {
        ...common,
        name: String(registration.userName || "").trim(),
        cpf: String(registration.userCpf || "").trim(),
        shirtSize: String(registration.shirtSizes?.player || "").trim(),
      };
      if (registration.registrationType !== "fixed_pair") return [player];
      const partnerName = String(registration.partnerName || "").trim();
      const partnerCpf = String(registration.partnerCpf || "").trim();
      const partner = {
        ...common,
        name: partnerName,
        cpf: partnerCpf,
        shirtSize: String(registration.shirtSizes?.partner || "").trim(),
      };
      return partnerName || partnerCpf ? [player, partner] : [player];
    });

  if (rows.length === 0) return false;

  const header = ["Nome", "CPF", "Tamanho", "Categoria", "Inscricao", "Evento"];
  const lines = [
    header.join(";"),
    ...rows.map((row) =>
      [
        row.name,
        row.cpf,
        row.shirtSize,
        row.category,
        row.registrationType,
        row.event,
      ]
        .map(csvEscape)
        .join(";"),
    ),
  ];
  const blob = new Blob([`﻿${lines.join("\n")}`], {
    type: "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `camisetas-${buildFileSlug(challengeName)}.csv`;
  anchor.click();
  URL.revokeObjectURL(url);
  return true;
}
